import { render, staticRenderFns } from "./v-footer-links.vue?vue&type=template&id=27efa38e&scoped=true&"
var script = {}
import style0 from "./v-footer-links.vue?vue&type=style&index=0&id=27efa38e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27efa38e",
  null
  
)

export default component.exports